<template>
  <van-overlay :show="visible" @click="onClick" class-name="ik-loading-overlay">
    <div class="wrapper" @click.stop>
      <van-loading type="spinner" size="24px" color="rgba(0,0,0,.7)" vertical>
        {{ text }}
      </van-loading>
    </div>
  </van-overlay>
</template>
<script>
export default {
  props: {
    onClick: {
      type: Function,
      default: () => {},
    },
    text: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      visible: false,
    };
  },
};
</script>
<style lang="scss">
.ik-loading-overlay {
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
}
</style>
<style lang="scss" scoped>
.wrapper {
  display: flex;
  height: 100%;
  justify-content: center;
  align-items: center;
  .van-loading {
    padding: 20px 40px;
    background: #fff;
    box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 10px;
  }
}
</style>